var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6223 37.9667C29.9613 37.8076 29.2676 37.726 28.6393 37.4771C26.5542 36.6529 25.1384 35.1432 24.5549 32.9765C23.8123 30.2224 24.5427 27.8314 26.6726 25.9381C28.2231 24.5631 30.0796 24.0326 32.136 24.355C34.6005 24.7426 36.3876 26.1054 37.3873 28.3781C38.3992 30.6834 38.1544 32.9439 36.7345 35.0248C35.6981 36.5427 34.2374 37.4648 32.4339 37.8361C32.1687 37.8892 31.9035 37.9218 31.6382 37.9667H30.6223ZM35.9511 31.1282C35.9592 28.4801 33.7926 26.3013 31.1364 26.2972C28.4924 26.2931 26.3298 28.4434 26.3094 31.0915C26.289 33.7396 28.4516 35.9225 31.1119 35.9347C33.76 35.951 35.9388 33.7844 35.9511 31.1282Z",
    fill: "#358AD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9355 27.7376V29.7329H19.928V27.7376H21.9355Z",
    fill: "#358AD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8714 33.7926H15.8721V31.7932H17.8714V33.7926Z",
    fill: "#358AD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.7045C12.1142 16.1823 12.2693 15.6763 12.6039 15.2438C13.2037 14.4685 13.9952 14.0524 14.9745 14.0156C15.3948 13.9993 15.815 14.0156 16.2557 14.0156V12.0041H18.2917V14.0034H31.6831V12H33.7069V14.0156C34.1435 14.0156 34.5556 14.0075 34.9677 14.0156C36 14.0442 36.8242 14.4767 37.4281 15.3132C37.7749 15.7906 37.9749 16.3332 37.9749 16.9208C37.9871 19.728 37.983 22.5352 37.983 25.3465C37.983 25.3628 37.9749 25.3791 37.9626 25.4199C37.9096 25.371 37.8647 25.3302 37.8198 25.2894C37.2608 24.7916 36.7018 24.2856 36.1347 23.8001C36.0163 23.6981 35.9511 23.6124 35.9511 23.4451C35.9633 22.8208 35.9551 22.1925 35.9551 21.5478H14.0279V21.813C14.0279 26.1258 14.0279 30.4386 14.0279 34.7515C14.0279 35.5471 14.4196 35.9388 15.2071 35.9388C17.949 35.9388 20.6868 35.9388 23.4288 35.9388C23.6083 35.9388 23.7062 36.0041 23.8246 36.1387C24.2979 36.6977 24.7957 37.2404 25.2812 37.7872C25.3342 37.8484 25.3914 37.9096 25.4485 37.9708H14.6889C14.6481 37.9545 14.6114 37.9341 14.5706 37.93C13.73 37.7953 13.069 37.371 12.5672 36.6937C12.253 36.2734 12.1102 35.7838 12 35.2819V16.7045ZM31.6954 16.0639H18.2877V18.0592H16.2557V16.0435C15.8477 16.0435 15.4682 16.0394 15.0887 16.0435C14.4604 16.0517 14.0401 16.472 14.036 17.1003C14.0279 17.7001 14.036 18.2999 14.036 18.8997C14.036 19.0915 14.036 19.2832 14.036 19.475H35.9551C35.9551 18.6386 35.9674 17.8184 35.9511 16.9983C35.9429 16.5168 35.5798 16.1088 35.1064 16.0639C34.6576 16.0231 34.2006 16.0558 33.7192 16.0558V18.0592H31.7035V16.0598L31.6954 16.0639Z",
    fill: "#358AD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8762 23.6614H17.8674V25.6689H15.8762V23.6614Z",
    fill: "#358AD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9396 23.6777V25.6688H19.9321V23.6777H21.9396Z",
    fill: "#358AD4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9952 23.6735V25.6688H23.9958V23.6735H25.9952Z",
    fill: "#358AD4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8762 27.7293H17.8755V29.7286H15.8762V27.7293Z",
    fill: "#358AD4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.928 33.7886V31.7892H21.9273V33.7886H19.928Z",
    fill: "#358AD4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0837 27.7293H32.0912V30.0918H33.809V32.1197H30.0878V27.7293H30.0837Z",
    fill: "#358AD4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#358AD4",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIco);
export default __webpack_public_path__ + "static/media/calendar_ico.ff72861491a96107acc01592b6160e6f.svg";
export { ForwardRef as ReactComponent };